import { create } from 'zustand';

interface OnboardingState {
  /**
   * Set when the user asks to replay onboarding from the avatar menu.
   * The active dashboard consumes this to re-open the Welcome card, then
   * calls clearReplay(). (When the audio Guided Tour lands, the same signal
   * can also kick off the demo.)
   */
  replayRequested: boolean;
  requestReplay: () => void;
  clearReplay: () => void;
}

export const useOnboardingStore = create<OnboardingState>((set) => ({
  replayRequested: false,
  requestReplay: () => set({ replayRequested: true }),
  clearReplay: () => set({ replayRequested: false }),
}));
